module.exports = __webpack_public_path__ + "static/media/vignan_logo.2956e004.png";